window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element.first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
     
      
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      if(found) {
        var variant = found;
        if (variant.available) {
          $('.backinstockClass').hide();
        }else{
          $('.backinstockClass').show();
        }
      }
// variant image select on page load
      
      if(found) {
        function changeImg(){
          var variant = found;
          if(variant.featured_image){
            var pts = Shopify.resizeImage(variant.featured_image.src,'1024x1024');
            if($('.product-img-slider').hasClass('slick-initialized')) {
              var ti = $('.product-img-slider .slide[data-src="'+pts+'"]').index();
              $('.product-img-slider').slick('slickGoTo', ti);
            } else {
              setTimeout(function(){
                changeImg()
              },500);
            }
          }
        }
        changeImg()
      }
      
// variant image select on page load
      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      if (variant) {
        //console.log(variant.id);
        var varId = variant.id;
        $('#checkout-btn-custom').attr('data-id',variant.id);
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this.currentVariant = variant;
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        if (variant.available) {
          $('.product-page .add-to-cart-section .btn.btn-success').html('Add to cart');
          $('.product-page .add-to-cart-section .buy_now_btn').css('display','block');
          $('.product-page .add-to-cart-section .btn.btn-success').prop('disabled', false);
          $('.buy_now').removeClass('hide');
          $('.backinstockClass').hide();
        }else{
          $('.product-page .add-to-cart-section .btn.btn-success').html('Sold Out');
          $('.product-page .add-to-cart-section .buy_now_btn').css('display','none');
        }
      }else{
        $('.product-page .add-to-cart-section .btn.btn-success').html('unavailable');
        $('.product-page .add-to-cart-section .btn.btn-success').prop('disabled', true);
        $('.product-page .add-to-cart-section .buy_now_btn').css('display','none');
        $('.buy_now').addClass('hide');
        $('.backinstockClass').show();
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

function load_quantity_controls(){
  $('.quantity-controls button.qty-plus').off().click(function(e){
    e.preventDefault();
    var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
    qtyInput.val(parseInt(qtyInput.val()) + 1);
    $('#checkout-btn-custom').attr('data-qty',qtyInput.val());
  });

  $('.quantity-controls button.qty-minus').off().click(function(e){
    e.preventDefault();
    var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
    var newQty = (parseInt(qtyInput.val()) - 1 < 1) ? 1 : qtyInput.val() - 1;
    qtyInput.val(newQty);
    $('#checkout-btn-custom').attr('data-qty',qtyInput.val());
  });
}

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    buynow: '[data-add-to-buy]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'

  };
  //   var autoplay = $('.product_gallery').data('autoplay');
  //   var autoplay1 = $('.product_gallery_main').data('autoplay');




  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#product-img-slider-' + sectionId;
    var thumbSlideshow = this.slideshow = '#thumb_slide-' + sectionId;
    var thumbSlideshowBelow = this.slideshow = '#thumb_slide-' + sectionId + '-thumb';
    var autoheight = $('.product-img-slider').attr('data-height');
    setTimeout(function(){
      if(autoheight == 'true' ){
        $(slideshow).slick({
          dots: true,
          infinite: false,
          arrows: true,  
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.thumb_slide',
          adaptiveHeight: true,
          swipeToSlide:true,
          prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0269/5479/3034/t/13/assets/left-arrow-pro.png'>",
          nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0269/5479/3034/t/13/assets/right-arrow-pro.png'>"
        });
      }else{
        $(slideshow).slick({
          dots: true,
          infinite: false,
          arrows: true,  
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide:true,
          asNavFor: '.thumb_slide',
          prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0269/5479/3034/t/13/assets/left-arrow-pro.png'>",
          nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0269/5479/3034/t/13/assets/right-arrow-pro.png'>"
        });
      }

      $(thumbSlideshow).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        asNavFor: '.product-img-slider', 
        arrows: false,
        infinite: false,
        centerMode: false,
        vertical:true, 
        focusOnSelect: true,
        swipeToSlide:true,
      });
      $('.thumbSlideshow').slick('refresh');

      $(thumbSlideshowBelow).slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        asNavFor: '.product-img-slider',
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        swipeToSlide:false,
        dots:true
      });

    },300);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      if (variant) {
        $(selectors.buynow).css('display','block');
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('unavailable');
        $(selectors.priceWrapper, this.$container).addClass('hide');
        $(selectors.buynow).css('display','none');
        return;
      }

      if (variant.available) {
        $(selectors.buynow).css('display','block');
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.buynow).css('display','none');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
      .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      var pts = Shopify.resizeImage(variant.featured_image.src,'1024x1024');
      var ti = $('.product-img-slider .slide[data-src="'+pts+'"]').index();
      //console.log("sdcs"+ti);
      $('.product-img-slider').slick('slickGoTo', ti);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/*======================================================================*/
/*							Slide show Section Start					*/
/*======================================================================*/

theme.slideshow = (function() {

  function slideshow(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;
    var autoplay = $(this.slideshow).data('autoplay');
    var slideshowSpeed = $(this.slideshow).data('slideshow-speed')*1000;
    var sliderAnimation = $(this.slideshow).data('slider-animation');
    $(slideshow).slick({
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: autoplay,
      dots: true,
      autoplaySpeed: slideshowSpeed,
      fade: sliderAnimation,
      prevArrow: "<button class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0269/5479/3034/files/left-arrows.png?2172' alt=''/></button>",
      nextArrow: "<button class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0269/5479/3034/files/right-arrows.png?2172' alt=''/></button>"
    });
  }
  return slideshow;
})();

theme.slideshow.prototype = _.assignIn(
  {},
  theme.slideshow.prototype,
  {
    onUnload: function() {
      $(this.slideshow).slick('unslick');
    },

    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    onDeselect: function() {
      
      if($(this.slideshow).data('autoplay')){
        $(this.slideshow).slick('slickPlay');
      }
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.slider-block--' + evt.detail.blockId);
      var slideIndex = $slide.attr('data-slick-index');

      // Go to selected slide, pause autoplay
      $(this.slideshow).slick('slickGoTo', slideIndex);
      $(this.slideshow).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      if($(this.slideshow).data('autoplay')){
        $(this.slideshow).slick('slickPlay');
      }
    }
  }
);
/*======================================================================*/
/*							Slide show Section End						*/
/*======================================================================*/



/*======================================================================*/
/*							Testimonials Section Start					*/
/*======================================================================*/

theme.testimonial = (function() {
  function testimonial(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var testimonial = this.testimonial = '#testimonials-' + sectionId;
    var slideDots = $(this.testimonial).data('slide-dots');
    var slideArrows = $(this.testimonial).data('slide-arrows');
    var slideshowSpeed = $(this.testimonial).data('slideshow-speed')*1000;
    var sliderAnimation = $(this.testimonial).data('slider-animation');

    $(testimonial).slick({
      dots: slideDots,
      arrows: slideArrows,
      speed: slideshowSpeed,
      autoplay: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      prevArrow: "<button class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0269/5479/3034/files/left-arrows.png?2172' alt=''/></button>",
      nextArrow: "<button class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0269/5479/3034/files/right-arrows.png?2172' alt=''/></button>"
    });
  }
  return testimonial;
})();

theme.testimonial.prototype = _.assignIn(
  {},
  theme.testimonial.prototype,
  {
    onUnload: function() {
      $(this.testimonial).slick('unslick');
    },

    onSelect: function() {
      $(this.testimonial).slick('slickPause');
    },

    onDeselect: function() {
      if($(this.testimonial).data('autoplay')){
        $(this.testimonial).slick('slickPlay');
      }
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.slide--' + evt.detail.blockId);
      var slideIndex = $slide.attr('data-slick-index');

      // Go to selected slide, pause autoplay
      $(this.testimonial).slick('slickGoTo', slideIndex);
      $(this.testimonial).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      if($(this.testimonial).data('autoplay')){
        $(this.testimonial).slick('slickPlay');
      }
    }
  }
);
/*======================================================================*/
/*							Testimonials Section End					*/
/*======================================================================*/

/*======================================================================*/
/*						Instagram Section End							*/
/*======================================================================*/
theme.isElementVisible = function($el, threshold) {
  var rect = $el[0].getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

theme.Instagram = (function() {
  var isInit = false;
  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.namespace = '.instagram-' + sectionId;
    this.$target = $('#Instafeed-' + sectionId);

    if (!this.$target.length) {
      return;
    }

    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    checkVisibility: function() {
      if (isInit) {
        $(window).off('scroll' + this.namespace);
        return;
      }
      if (theme.isElementVisible(this.$container)) {
        this.init();
      }
    },
    init: function() {
      isInit = true;

      var userId = this.$target.data('user-id');
      var clientId = this.$target.data('client-id');
      var count = parseInt(this.$target.data('count'));
      var line = this.$target.data('grid');
      var dd = this.$target.data('insta-group');
      var space = this.$target.data('space');
      // Ask for 2 more images than we'll actually show because
      // Instagram sometimes doesn't send enough
      if(space == true){
        var instaClass = 'insta-col';   

      }else{
        var instaClass = '';   
      }
      var feed = this.feed = new Instafeed({
        target: this.$target[0],
        accessToken: clientId,
        get: 'user',
        userId: userId,
        limit: count,
        template: '<div class="'+instaClass+' '+ dd+'"><div class="image-wrap"><a href="" target="_blank" style="background-image: url(); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
        resolution: 'standard_resolution'
      });

      feed.run();

      this.$target.addClass('instagram-holder--active');
    }
  });

  return Instagram;
})();

theme.Instagram.prototype = _.assignIn(
  {},
  theme.Instagram.prototype,
  {   
    onSelect: function() {
      $('.instagram-holder').empty();
      var userId = this.$target.data('user-id');
      var clientId = this.$target.data('client-id');
      var count = parseInt(this.$target.data('count'));
      var space = this.$target.data('space');
      var dd = this.$target.data('insta-group');
      if(space == true){
        var instaClass = 'insta-col';   

      }else{
        var instaClass = '';   
      }
      var feed = this.feed = new Instafeed({
        target: this.$target[0],
        accessToken: clientId,
        get: 'user',
        userId: userId,
        limit: count,
        template: '<div class="'+instaClass+' '+ dd+'"><div class="image-wrap"><a href="" target="_blank" style="background-image: url(); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
        resolution: 'standard_resolution'
      });
      feed.run();
      this.$target.addClass('instagram-holder--active');
    }    
  }
);

/*======================================================================*/
/*						Instagram Section End							*/
/*======================================================================*/


/*======================================================================*/
/*						Video Section End							*/
/*======================================================================*/
var VIDEO_PLAYING = 1, VIDEO_PAUSED = 2, VIDEO_STOPPED = 3;
function is_scrolled_into_view($element) {
  var $w = $(window);
  var docViewTop = $w.scrollTop();
  var docViewBottom = docViewTop + $w.height();

  var elemCenter = $element.offset().top + $element.outerHeight() / 2.0;

  return ((elemCenter >= docViewTop && elemCenter <= docViewBottom));
}

var insideViewCheckTimeout = null, wasInsideView = false;
function visibility_tracker($element, scrolled_into_view_cb, scrolled_out_of_view_cb) {
  wasInsideView = is_scrolled_into_view($element);
  if (wasInsideView) {
    scrolled_into_view_cb();
  }

  $(window).scroll(function() {
    check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb);
  });

  $(window).resize(function() {
    check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb);
  });
  check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb);
}

function check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb) {
  if (insideViewCheckTimeout) {
    clearTimeout(insideViewCheckTimeout);
  }
  insideViewCheckTimeout = setTimeout(function () {
    insideViewCheckTimeout = null;

    var isInsideView = is_scrolled_into_view($element);

    if (wasInsideView && !isInsideView) {
      scrolled_out_of_view_cb();
    }

    if (!wasInsideView && isInsideView) {
      scrolled_into_view_cb();
    }
    wasInsideView = isInsideView;
  }, 100);
}
function load_youtube(element) {
  var autoplay = element.dataset.videoAutoplay === "true",
      mute = element.dataset.videoMute === "true",
      loop = element.dataset.videoLoop === "true",
      $element = $(element),
      $parent = $(element).parent(),
      $overlay = $element.closest('.video-section').find('.video-overlay');

  player = new YT.Player(element.id, {
    width: 746,
    videoId: element.dataset.videoLink,
    playerVars: {
      showinfo: 0,
      modestbranding: 1,
      rel: 0
    },
    events: {
      onReady: function (event) {
        var video = event.target;
        if (autoplay) {
          $parent.data('pausedAutomatically', true);
        }
        if (mute) {
          video.mute();
        }

        visibility_tracker(
          $parent,
          function scrolled_into_view() {
            if ($parent.data('pausedAutomatically')) {
              video.playVideo();
            }
          },
          function scrolled_out_of_view() {
            $overlay.removeClass('active');
            if (video.getPlayerState() === YT.PlayerState.PLAYING) {
              $parent.data('pausedAutomatically', true);
              video.pauseVideo();
            }
          }
        )
      },
      onStateChange: function (event) {
        if (event.data === YT.PlayerState.PLAYING) {
          if (!autoplay) {
            $overlay.addClass('active');
          }
          $parent.data('pausedAutomatically', false);
        }

        if (event.data === YT.PlayerState.ENDED && loop) {
          event.target.playVideo();
        }
      }
    }
  });
}

function load_youtube_all() {
  $('.youtube-video').each(function (index, el) {
    load_youtube(el);
  });
}

function load_youtube_api() {
  if (!document.querySelector('.youtube-video')) {
    // No youtube elements, do not load youtube API
    return;
  }

  if (!document.querySelector('#youtube_api')) {
    // Youtube API is not yet loaded, create script that loads it
    create_script("youtube_api", "https://www.youtube.com/player_api");

    // Call 'youtube_load_all' as soon as the API is loaded
    window.onYouTubePlayerAPIReady = load_youtube_all;
  } else if (!window.YT) {
    // Script for loading youtube API is there, but youtube is not yet loaded,
    // load_youtube_all will be called when script finishes loading
  } else {
    // We already have youtube API loaded, call 'load_youtube_all'
    load_youtube_all();
  }
}
function load_vimeo_api() {
  if (!document.querySelector('.vimeo-video')) {
    // No vimeo elements, do not load vimeo API
    return;
  }

  if (!document.querySelector('#vimeo_api')) {
    // Vimeo API is not yet loaded, create script that loads it
    var script = create_script("vimeo_api", "https://player.vimeo.com/api/player.js");

    if (script.readyState) {
      // IE
      script.onreadystatechange = function() {
        if (element.readyState == "loaded" || element.readyState == "complete") {
          element.onreadystatechange = null;
          load_vimeo_all();
        }
      };
    } else {
      // Other browsers
      script.onload = function() {
        load_vimeo_all();
      };
    }
  } else if (!window.Vimeo) {
    // Script for loading vimeo API is there, but vimeo is not yet loaded,
    // load_vimeo_all will be called when script finishes loading
  } else {
    // We already have vimeo API loaded, call 'load_vimeo_all'
    load_vimeo_all();
  }
}

function create_script(id, src) {
  var tag = document.createElement('script');
  tag.id = id;
  tag.src = src;
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  return tag;
}

theme.video = (function() {
  function video(container) {
    load_youtube_api();
    load_vimeo_api();
  }
  return video;
})();

/*======================================================================*/
/*						Video Section End							*/
/*======================================================================*/


/*======================================================================*/
/*							Map Section Start							*/
/*======================================================================*/

theme.map = (function() {
  function map(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    // alert('Map')
  }
  return map;
})();

/*======================================================================*/
/*							Map Section End								*/
/*======================================================================*/




/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();




$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.slideshow);
  sections.register('testimonial-section', theme.testimonial);
  sections.register('instagram', theme.Instagram);
  sections.register('video-section', theme.video);
  sections.register('map-section', theme.map);
  load_quantity_controls();
  slate.a11y.pageLinkFocus($(window.location.hash));


  $('#checkout-btn-custom').click(function(e){
    var qty= $(this).attr('data-qty');
    var id= $(this).attr('data-id');
    var store = $(this).attr('data-store');
    var url = store+"/cart/"+id+":"+qty;
    $(this).attr('href',url);
  });


  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  
  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });

  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });

  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });
  
  $('#backinstock').click(function(){
    $('.product-out-of-stock').show();
  });
  $('.closeBTN, .product-out-of-stock .outOverlay').click(function(){
  	$('.product-out-of-stock').hide();
  });
  
});

$(document).ready(function(){
  $('#notify-me a').click(function(e) {
    e.preventDefault();
    $('#notify-me-wrapper').fadeIn();
  });	

  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    var $agree = $('#agree');
    if ($agree.length === 0 || $agree.is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
    });

  $('.qtyAdjustBox a').on('click', function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);
  });


  // minicart

  refreshHeigh();

  $(window).resize(function(){
    setTimeout(function() {
      refreshHeigh();
      $('.cartDrawer').css("height", window.innerHeight+'px');
    }, 50); 
  });

  function refreshHeigh() {
    var bh = parseInt($('.cartButtonOuter').height()+65);
    var extrabh = parseInt($('.extra-checkout-buttons').innerHeight());
    var vh = $(window).height();    
    var newh = vh-bh+5;
    var qih = $('.quick-items').height();

    $('.cartDrawer').removeClass('nofix');
    $('.quick-items').removeAttr('style');
    if(newh > 165) { // 115 is one line-item height in cart 
      if(qih > newh) {
        $('.quick-items').css('max-height',newh+'px').css('overflow-y','scroll');
      }
    }
    else {
      $('.cartDrawer').addClass('nofix');
    }
  }
  function addToCartSuccess() {
    $.get( "/cart?view=mini-cart", function( data ) {
      //     console.log(data);
      $('#crt').html(data);
      $('#crt').removeClass('loading');
      //       if($(window).width()>768){
      //         setTimeout(function() {
      //           refreshHeigh();
      //         }, 100);
      //       }
    });
    setTimeout(function() {
      Currency.convertAll(shopCurrency,jQuery("[name=currencies]").val());
    }, 500);
  }
      
  $('.add-to-cart').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
    }, 50);
  });

  function refreshCart(count) {
    $.getJSON('/cart.js', function(cart){
      $('.cart-count').text(cart.item_count);
    });
  }

  $('body').on('click',' #add-to-cart',function(e){
    //      alert('Dummy');
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');

    form.find('.error').remove();

    if(form.find('.select_size').length) {
      if(!form.find('.select_size').find('input:checked').length) {
        form.append('<p class="error">Please select size.</p>').find('.error').fadeIn().delay(4000).fadeOut();
        return false;
      }
    }

    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();
    //     console.log(form.serialize());
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      //       console.log(data);
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      refreshCart();
      $('.overlayquick').removeClass('active');
      $('.productGrid .productItem').removeClass('qvopen');
      $('body').addClass('cartOpen');
      $('.PageOverlay').addClass('is-visible');
      $('.fullPage').addClass('witmenu');
    });

  });


  $('body').on('click', '.quick-cart-details .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      },
      success: function(){
        addToCartSuccess();
        refreshCart();
        $('#crt').removeClass('loading');
      }
    });

  });

  $('body').on('click','.adjusted', function(e){
    $('#cartPage').addClass('loading');
    e.preventDefault();
    var i = parseInt($(this).closest('.qtyBox').find('input').val());
    if($(this).hasClass('plusQty')) 
      i = i + 1;
    else 
      i = i - 1;
    //if(i > 0)
    $(this).closest('.qtyBox').find('input').val(i);
    var li = $(this).closest('.qtyBox').find('input').attr('data-line');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      async:false,
      data: { line: li, quantity: i },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#cartPage').removeClass('loading');
      },
      success: function() {
        $.getJSON('/cart.js', function(c){
          $('.cart_count').text(c.item_count);
        });
        $.get( "/cart?view=full", function( data ) {
          $('#cartPage').html(data);
          $('#cartPage').removeClass('loading');
        });

      }
    });
  });

  $("#crt").on('click', "a.remove_item", function(r){
    //alert('loading');
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount, .cart-count').text(c.item_count);
      if(!c.item_count) {
        $('.itemCount').text('0');
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
      }else {
        addToCartSuccess();
        $('#crt').removeClass('loading');
      }
    });
  });


  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart,.PageOverlay,.closecart1', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('.PageOverlay').removeClass('is-visible');
    $('body').removeClass('cartOpen');
  });

  $('.menu-overlay').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
  });
  

});
